module.exports = __webpack_public_path__ + "static/haiwai_yewu.ac3b3d29.jpg";